let comuni = require('./italia_solo_comuni.json');

let data = {comuni: comuni};

module.exports = data;


// WEBPACK FOOTER //
// ./src/vendor/italia/index.js